import React, { useState, useCallback } from "react";
import { Button, Modal, TextContainer, Toast } from "@shopify/polaris";
import styled from "styled-components";
import { gql } from "apollo-boost";
import { useMutation } from "@apollo/react-hooks";

import { handleError } from "../../../helper";
import history from "../../../history";
import { LIST_COLLECTION } from "./ListCollectionPolaris";

const Container = styled.div`
  button + button {
    margin-left: 0.75rem;
  }
`;

const DELETE_COLLECTION = gql`
  mutation deleteCollection($id: ID!) {
    deleteCollection(id: $id)
  }
`;

export const ColActionsPolaris = ({ collection, filter, currentParam }) => {
  const [open, setOpen] = useState(false);
  const [activeToast, setActiveToast] = useState(false);
  const [deleteCollection, { data, error, client, loading }] = useMutation(
    DELETE_COLLECTION,
    {
      onCompleted: () => {
        handleModalChange();
      },
    }
  );

  const handleClick = useCallback(() => {
    history.push(`/${currentParam}/edit/collection/${collection.id}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleModalChange = useCallback(() => setOpen((open) => !open), []);
  const toggleActive = useCallback(() => {
    setActiveToast((activeToast) => !activeToast);
  }, []);

  const toastMarkup = activeToast
    ? (error || (data && data.deleteCollection)) && (
        <Toast
          content={
            error
              ? handleError(error.toString())
              : data && data.deleteCollection && "Collection has been deleted!"
          }
          error={error}
          duration={2000}
          onDismiss={toggleActive}
        />
      )
    : null;

  const deleteCollectionState = (collections, id) => {
    for (let i = 0; i < collections.length; i++) {
      const c = collections[i];
      if (c.id === id) {
        collections.splice(i, 1);
        break;
      }
      if (c.children && c.children.length) {
        c.children = deleteCollectionState(c.children, id);
      }
    }
    return collections;
  };

  return (
    <Container>
      <Button onClick={handleClick} plain>
        Edit
      </Button>
      {/* <Button onClick={handleModalChange} plain>
        Delete
      </Button> */}
      <Modal
        title={"Delete collection"}
        open={open}
        onClose={handleModalChange}
        primaryAction={{
          content: "Delete",
          loading: loading,
          onAction: () => {
            deleteCollection({
              variables: { id: collection.id },
            })
              .then((res) => {
                if (res) {
                  try {
                    const cache = client.readQuery({
                      query: LIST_COLLECTION,
                      variables: {
                        filter: { ...filter },
                      },
                    });
                    const cat = deleteCollectionState(
                      JSON.parse(JSON.stringify(cache.collections.nodes)),
                      collection.id
                    );
                    client.writeQuery({
                      query: LIST_COLLECTION,
                      variables: {
                        filter: { ...filter },
                      },
                      data: {
                        ...cache,
                        collections: {
                          ...cache.collections,
                          nodes: cat,
                        },
                      },
                    });
                  } catch (_) {}
                }
              })
              .catch(() => {});
            toggleActive();
          },
        }}
        secondaryActions={[
          {
            content: "Cancel",
            onAction: handleModalChange,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure to delete this collection?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Container>
  );
};
